import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { useI18n } from "Hooks";

import { Tooltip, IconButton } from "@toddle-edu/ds-web";
import { MinusCircleOutlined } from "@toddle-edu/ds-icons";
import MessagingAvatar from "MessagingV2/components/ThreadList/Avatar/Avatar";
import {
  getDefaultNameSortPreference,
  getDefaultStudentNameOrderPreference,
} from "modules/CommonSelectors";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import ConditionalWrapper from "Utils/ConditionalWrapper";

import {
  SUB_TEXT_LENGTH,
  getFormattedNameForUserType,
  getSubText,
} from "MessagingV2/modules/Utils";
import { isIdEqual } from "Utils";

import classNames from "classnames";
import classes from "./UserTypeList.scss";

const UserTypeCard = ({
  onRemoveClick,
  avatarId,
  mainText,
  subText,
  profileImage,
  isRemovable,
}) => {
  return (
    <div className={classes.userTypeCardContainer}>
      <MessagingAvatar
        id={avatarId}
        name={mainText}
        url={profileImage}
        onlineStatus={false}
      />
      <div className={classes.userInfoContainer}>
        <div className="text-body-1">{mainText}</div>
        {subText ? (
          <ConditionalWrapper
            wrapper={<Tooltip tooltip={subText} />}
            condition={_.size(subText) > SUB_TEXT_LENGTH}
            type={"wrapperAsElement"}
          >
            <div className={classNames("text-body-2", classes.userSubTitle)}>
              {_.truncate(subText, { length: SUB_TEXT_LENGTH })}
            </div>
          </ConditionalWrapper>
        ) : null}
      </div>
      {isRemovable ? (
        <div className={classes.iconButtonContainer}>
          <IconButton
            icon={<MinusCircleOutlined />}
            variant="plain"
            size="medium"
            onClick={onRemoveClick}
            className={classes.removeIcon}
          />
        </div>
      ) : null}
    </div>
  );
};

const UserTypeList = ({
  users,
  onRemoveClick,
  customAvatarContainerClassName,
  defaultStudentNameSortPreference,
  defaultStudentNameOrderPreference,
  loggedInUserId,
  loggedInUserType,
  isMemberUpdate,
}) => {
  const { t } = useI18n(["common"]);

  return _.map(users, user => {
    const isCurrentLoggedInUser = isIdEqual(loggedInUserId, user.id);

    const { id, profileImage } = user;

    let name = getFormattedNameForUserType({
      user,
      orderBy: defaultStudentNameSortPreference,
      isFormattedNameV2: true,
      defaultStudentNameOrderPreference,
    });

    if (isCurrentLoggedInUser) {
      name = t("common:you_with_full_name", { fullName: name });
    }
    return (
      <UserTypeCard
        key={id}
        onRemoveClick={() => onRemoveClick({ user })}
        customAvatarContainerClassName={customAvatarContainerClassName}
        avatarId={id}
        mainText={name}
        subText={getSubText({
          loggedInUserRole: loggedInUserType,
          messagedUserObj: user,
          messagedUserRole: _.get(user, "type"),
          t,
          defaultStudentNameSortPreference,
        })}
        profileImage={profileImage}
        isRemovable={isMemberUpdate && !isCurrentLoggedInUser}
      />
    );
  });
};

const mapStateToProps = state => {
  const defaultStudentNameSortPreference = getDefaultNameSortPreference(state);
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );
  const { user_type: loggedInUserType, id: loggedInUserId } = getUserInfo();
  return {
    defaultStudentNameSortPreference,
    loggedInUserType,
    loggedInUserId,
    defaultStudentNameOrderPreference,
  };
};

export default connect(mapStateToProps)(UserTypeList);
